<ng-content />

@if (editable()) {
  <button lyceoButton class="mt-3" *transloco="let t" (click)="edit.emit()">
    <fa-icon [icon]="faPenToSquare" />
    {{ t('general.edit') }}
  </button>
}
